module.exports = __webpack_public_path__ + "static/media/catering-services.ef799367.jpg";